module.exports = __webpack_public_path__ + "static/media/p3.656d9c15.jpeg";